import script from "./BAASigningPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BAASigningPage.vue?vue&type=script&setup=true&lang=js"

import "./BAASigningPage.vue?vue&type=style&index=0&id=cdb92612&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb92612"]])

export default __exports__